export const SORT_TYPES = {
  BEST: 'BEST',
  CHEAPEST: 'CHEAPEST',
  FASTEST: 'FASTEST',
  DEPARTURE_OUTBOUND_ASC: 'DEPARTURE_OUTBOUND_ASC',
  DEPARTURE_INBOUND_ASC: 'DEPARTURE_INBOUND_ASC',
} as const;

export type SortTypes = keyof typeof SORT_TYPES;

export const { BEST, CHEAPEST, DEPARTURE_INBOUND_ASC, DEPARTURE_OUTBOUND_ASC, FASTEST } =
  SORT_TYPES;

export const SORT_OPTION_BY_LEG_INDEX: Record<number, SortTypes> = {
  0: DEPARTURE_OUTBOUND_ASC,
  1: DEPARTURE_INBOUND_ASC,
};
